import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-request-note-create-modal',
    templateUrl: './request-note-create-modal.component.html',
    styleUrls: ['./request-note-create-modal.component.css']
})
export class RequestNoteCreateModalComponent implements OnInit {
    noteText = '';

    constructor(public activeModal: NgbActiveModal) { }

    ngOnInit(): void {
    }

    confirm(): void {
        const text = this.noteText.trim();
        if (!text) {
            return;
        }
        this.activeModal.close(text);
    }
}
